import { IRecordType } from 'types/recordType';
import { getRecordTypeSlug } from 'utils/recordTypeSlug';

export const getRecordViewerURL = (recordId: string, type: Pick<IRecordType, 'id' | 'name'>): string => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl) return '';
    return window.location.host.includes('localhost')
        ? `${window.location.host}${tenantUrl}/accounting/doc-viewer/${getRecordTypeSlug(type.name)}?recordId=${recordId}&recordType=${
              type.id
          }`
        : `https://${window.location.host}${tenantUrl}/accounting/doc-viewer/${getRecordTypeSlug(
              type.name
          )}?recordId=${recordId}&recordType=${type.id}`;
};

export const getDataFocusViewURL = (recordId: string, type: Pick<IRecordType, 'id' | 'name'>): string => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl) return '';
    return window.location.host.includes('localhost')
        ? `${window.location.host}${tenantUrl}/data-focus-view/${getRecordTypeSlug(type.name)}?recordId=${recordId}&recordType=${type.id}`
        : `https://${window.location.host}${tenantUrl}/data-focus-view/${getRecordTypeSlug(type.name)}?recordId=${recordId}&recordType=${
              type.id
          }`;
};
